import React, { useContext, useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Button,
  Col,
  Container,
  Row,
  Card,
  Form,
  Table,
} from "react-bootstrap";
import Nav from "./Navbar";
import Footer from "./Footer";
import tool5 from "../Images/tool5.png";
import tool4 from "../Images/tool4.png";
import Domainpage from "./Dapa";
import SideTab from "./Toolstab";
import key1 from "../Images/key1.svg";
import key2 from "../Images/key2.svg";
import key3 from "../Images/key3.svg";
import key4 from "../Images/key4.svg";
import key5 from "../Images/key5.svg";
import key6 from "../Images/cardimg5.svg";
import core1 from "../Images/core1.png";
import core2 from "../Images/core2.png";
import core3 from "../Images/core3.png";
import core4 from "../Images/core4.png";
import core5 from "../Images/core5.png";
import core6 from "../Images/core6.png";
import pay from "../Images/pay.png";
import {
  FaArrowRight,
  FaChartBar,
  FaChevronLeft,
  FaChevronRight,
  FaFileAlt,
  FaSearch,
} from "react-icons/fa";
import TestimonialPage from "./Testonomialraghar";
import { useNavigate } from "react-router-dom";
import { BASE_URL_API_TRANXT_UAT_API } from "../Utils/Constant";
import { basicauth } from "../Utils/Credentials";
import { Helmet } from "react-helmet";
const relatedTools = [
  {
    name: "SERP Simulator",
    icon: <FaSearch size={24} color="#0A3981" />,
    desc: "See how your site appears in Google results. A well-organized snippet can boost exposure, encourage more clicks, and enhance SEO performance in general.",
    href: "/serp-simulator",
  },
  {
    name: "Keyword Gap",
    icon: <FaChartBar size={24} color="#0A3981" />,
    desc: "Discover which keywords your competitors rank for that you don't. Uncover content opportunities, improve targeting, and close the gap in organic traffic efficiently.",
    href: "/keyword-gap",
  },
  {
    name: "Top Pages",
    icon: <FaFileAlt size={24} color="#0A3981" />,
    desc: "Identify your highest-performing pages by traffic and engagement. Use this insight to replicate success and refine your SEO content strategy effectively.",
    href: "/top-pages",
  },
];
const ToolSlider = () => {
  const sliderRef = useRef(null);

  const scrollLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollLeft -= 300;
    }
  };

  const scrollRight = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollLeft += 300;
    }
  };

  return (
    <div style={{ position: "relative" }}>
      {/* Left Arrow */}
      <button
        onClick={scrollLeft}
        style={{
          position: "absolute",
          left: "0",
          top: "-9%",
          transform: "translateY(-50%)",
          zIndex: 10,
          backgroundColor: "#799EFF",
          color: "#fff",
          border: "none",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          cursor: "pointer",
          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        }}
      >
        <FaChevronLeft />
      </button>

      <button
        onClick={scrollRight}
        style={{
          position: "absolute",
          right: "0",
          top: "-9%",
          transform: "translateY(-50%)",
          zIndex: 10,
          backgroundColor: "#799EFF",
          color: "#fff",
          border: "none",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          cursor: "pointer",
          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        }}
      >
        <FaChevronRight />
      </button>

      <div
        ref={sliderRef}
        className="mb-4"
        style={{
          display: "flex",
          overflowX: "auto",
          padding: "1rem",
          gap: "1rem",
          scrollbarWidth: "none",
          scrollBehavior: "smooth",
        }}
      >
        {relatedTools.map((tool, idx) => (
          <div
            key={idx}
            style={{
              minWidth: "250px",
              flex: "0 0 auto",
              background: "#f4f8ff",
              borderRadius: "12px",
              padding: "1rem",
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              textAlign: "center",
              transition: "transform 0.3s",
            }}
          >
            <div style={{ marginBottom: "0.5rem" }}>{tool.icon}</div>
            <h6 style={{ color: "#0A3981", fontWeight: "bold" }}>
              {tool.name}
            </h6>
            <p
              style={{
                fontSize: "0.9rem",
                minHeight: "60px",
                lineHeight: "1.4",
              }}
            >
              {tool.desc
                .split(" ")
                .map((word, i) =>
                  (i + 1) % 7 === 0 ? word + "\n" : word + " "
                )
                .join("")
                .split("\n")
                .map((line, idx) => (
                  <span key={idx}>
                    {line.trim()}
                    <br />
                  </span>
                ))}
            </p>
            <a
              href={tool.href}
              style={{
                color: "#fff",
                backgroundColor: "#799EFF",
                padding: "6px 12px",
                borderRadius: "8px",
                textDecoration: "none",
                display: "inline-block",
                fontWeight: "bold",
              }}
            >
              Try Now →
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};
const Domainoverview = () => {
  const jsonLdData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Seobix DA PA Checker – Domain & Page Authority Tool",
    url: "https://seobix.com/da-pa-checker",
    description:
      "Use Seobix’s DA PA Checker to instantly analyze domain and page authority. Get reliable insights to boost your SEO and monitor site strength.",
    publisher: {
      "@type": "Organization",
      name: "Seobix",
      url: "https://seobix.com",
      logo: {
        "@type": "ImageObject",
        url: "https://seobix.com/Images/Backlinks.png",
      },
    },
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "DA PA Checker",
          item: "https://seobix.com/da-pa-checker",
        },
      ],
    },
    mainEntity: {
      "@type": "SoftwareApplication",
      name: "Seobix DA PA Checker",
      applicationCategory: "SEO Tool",
      operatingSystem: "Web",
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "USD",
        category: "Free SEO Tool",
      },
    },
    inLanguage: "en",
    keywords: [
      "domain authority",
      "da pa check",
      "check domain rating",
      "check website authority",
      "check domain authority",
      "domain ranking check",
      "check the domain authority",
      "check domain and page authority",
      "check pa and da",
      "check pa da of website",
      "da and pa check",
      "check site authority",
      "website authority check",
    ],
  };
  

  return (
    <div>
      <Helmet>
        <title>Seobix DA PA Checker – Domain & Page Authority Tool</title>
        <meta
          name="description"
          content="Use Seobix’s DA PA Checker to instantly analyze domain and page authority. Get reliable insights to boost your SEO and monitor site strength."
        />
        <meta
          name="keywords"
          content="domain authority, da pa check, check domain rating, check website authority, check domain authority, domain ranking check, check the domain authority, check domain and page authority, check pa and da, check pa da of website, da and pa check, check site authority, website authority check"
        />
        <link rel="canonical" href="https://seobix.com/da-pa-checker" />

        <meta
          property="og:title"
          content="Seobix DA PA Checker – Domain & Page Authority Tool"
        />
        <meta
          property="og:description"
          content="Use Seobix’s DA PA Checker to instantly analyze domain and page authority. Get reliable insights to boost your SEO and monitor site strength."
        />
        <meta property="og:url" content="https://seobix.com/da-pa-checker" />
        <meta property="og:site_name" content="Seobix" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://seobix.com/Images/Backlinks.png"
        />
        <meta property="og:image:width" content="600" />
        <meta property="og:image:height" content="600" />
        <meta property="og:locale" content="en_US" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Seobix DA PA Checker – Domain & Page Authority Tool"
        />
        <meta
          name="twitter:description"
          content="Use Seobix’s DA PA Checker to instantly analyze domain and page authority. Get reliable insights to boost your SEO and monitor site strength."
        />
        <meta
          name="twitter:image"
          content="https://seobix.com/Images/Backlinks.png"
        />
        <meta name="twitter:site" content="@seobix" />
        <meta name="twitter:creator" content="@seobix" />

        <script type="application/ld+json">{JSON.stringify(jsonLdData)}</script>
      </Helmet>
      <Nav />
      <Container fluid className="p-0">
        <Row
          className="justify-content-center"
          style={{
            margin: "0",
            background:
              "linear-gradient(to right, #AFDDFF 0%, #C5E7FF 30%, #DAF0FF 60%, #EDF8FF 85%, #FFFFFF 100%)",
          }}
        >
          <Col md={10}>
            <h1
              style={{ color: "#0A3981" }}
              className="pt-5 text-center fw-bold"
            >
              Check Domain Authority and Age Instantly
            </h1>
            <Domainpage />
          </Col>
        </Row>

        <Row className="justify-content-center" style={{ margin: "0" }}>
          <Col md={10}>
            <Row className="justify-content-between">
              <Col md={8}>
                <Content />
              </Col>

              <Col md={3}>
                <div
                  className="mb-5"
                  style={{
                    position: "sticky",
                    top: "100px",
                    zIndex: 10,
                    background: "#f8f9fa",
                    padding: "1rem",
                    borderRadius: "10px",
                  }}
                >
                  <h5
                    className="text-center mb-4"
                    style={{
                      fontWeight: "bold",
                      fontSize: "1.3rem",
                      color: "#fff",
                      backgroundColor: "#799EFF",
                      display: "inline-block",
                      padding: "6px 16px",
                      borderRadius: "0.5rem",
                    }}
                  >
                    🚀 Explore More SEO Tools
                  </h5>
                  <SideTab />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      <div
        className="m-0 p-0"
        style={{
          overflow: "hidden",
          background:
            "linear-gradient(to right, rgb(175, 221, 255), rgb(255, 255, 255))",
          borderTopRightRadius: "2rem",
          borderTopLeftRadius: "2rem",
        }}
      >
        <Footer />
      </div>
    </div>
  );
};
const Content = () => {
  const [showMore, setShowMore] = useState(false);

  return (
    <div className="">
      <h2 className=" mt-md-4">
        Free DA PA Checker – Know How Strong Your Domain Is?
      </h2>

      <p className=" mt-2">
        When you’re building a website or working on SEO, one thing that matters
        more than most people realize is website authority. You might have
        amazing content, great design, and some decent backlinks, but if your
        domain doesn’t carry weight, Google might not care.
      </p>
      <p className=" mt-2">
        That’s where a free DA PA checker or website authority analyzer comes
        in. It allows you to evaluate your domain’s authority, understand its
        SEO credibility, and pinpoint opportunities to boost its performance..
        Whether you’re running one site or managing client portfolios, this free
        DA PA checker gives you a clear picture of your website authority using
        a simple domain SEO check.
      </p>

      <h3>What Is Website Authority?</h3>
      <div style={{ position: "relative" }}>
        <p>
          Website authority is a measure of how trustworthy your site appears to
          be based on the quality and quantity of backlinks. It doesn’t come
          from Google officially, but tools like SeoBix give you a number — a
          score — to help you understand how strong your site is compared to
          others through a domain SEO check or bulk domain authority checker.
        </p>
        {!showMore && (
          <div
            style={{
              position: "absolute",
              bottom: "0.5rem",
              left: 0,
              right: 0,
              height: "2.5em",
              background:
                "linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.8) 100%)",
            }}
          />
        )}
      </div>
      <div className="d-flex justify-content-center">
        {!showMore && (
          <Button
            onClick={() => setShowMore(true)}
            style={{
              padding: "6px 20px",
              backgroundColor: "#fff",
              color: "#0d6efd",
              fontWeight: "600",
              fontSize: "0.95rem",
              border: "2px solid #0d6efd",
              borderRadius: "999px",
              boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#0d6efd";
              e.target.style.color = "#fff";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#fff";
              e.target.style.color = "#0d6efd";
            }}
          >
            Read More
          </Button>
        )}
      </div>

      {showMore && (
        <>
          <p>This is where DA and PA come in.</p>
          <ul>
            <li>
              <strong>DA</strong> stands for Domain Authority — it tells you how
              strong your entire website is.
            </li>
            <li>
              <strong>PA</strong> is Page Authority — it focuses on individual
              pages on your site.
            </li>
          </ul>
          <div className="d-flex justify-content-center">
            <img
              className="mb-3"
              src={tool4}
              alt="seobix"
              style={{ width: "50vw" }}
            />
          </div>
          <p>
            These are not just numbers; they are based on real metrics like
            backlinks, referring domains, and link quality. So while they are
            not a direct ranking factor in Google’s algorithm, they still help
            you see how well your SEO efforts are working. A free DA PA checker
            simplifies that process.
          </p>

          <h3>How SeoBix Calculates DA and PA</h3>
          <p>
            Unlike a lot of tools that overwhelm you with data, SeoBix’s website
            authority analyzer keeps it simple. When you run a domain SEO check,
            it gives you a clear and easy-to-understand matrix.
          </p>
          <p>
            We look at how many websites are linking to yours. Then we check how
            trustworthy those sites are. If you’re getting links from solid,
            well-established domains, that helps. Spammy links? Not so much.
          </p>
          <p>
            We also examine how many other sites those linking domains are
            pointing to. If a domain is linking out to thousands of sites, the
            value of its link drops.
          </p>
          <h4
            className="text-center mt-4 mb-3"
            style={{
              fontWeight: "bold",
              fontSize: "1.5rem",
              color: "#0A3981",
            }}
          >
            🔧 Related Tools
          </h4>

          <ToolSlider />

          <p>
            All this data runs through our free DA PA checker, and you get your
            DA and PA scores on a scale of 0 to 100. Higher is better, of
            course.
          </p>
          <p>
            Our website authority analyzer is built to keep things clean — no
            distractions, just the numbers and what they mean.
          </p>

          <h3>Why Website Authority Even Matters</h3>
          <p>You might ask, does this even help with rankings?</p>
          <p>Fair question.</p>
          <p>
            Google doesn’t say they use DA or PA, but they do consider the
            signals that make up those scores: backlinks, link quality, and
            trustworthiness. When you check domain authority regularly using a
            free DA PA checker, you’re actually monitoring some of the most
            important off-page SEO signals.
          </p>
          <p>
            When your site has higher website authority, a few things happen
            naturally:
          </p>
          <ul>
            <li>Your content tends to rank faster</li>
            <li>You earn links more easily</li>
            <li>Google crawls your site more often</li>
            <li>You look more credible to users and other site owners</li>
          </ul>
          <p>
            In short, strong website authority boosts your SEO, even if the
            metric itself isn’t in Google’s formula.
          </p>

          <h3>What’s a Good Domain Authority Score?</h3>
          <p>This one trips people up.</p>
          <p>
            There’s no universal number that makes your DA good. A DA of 25
            might be great in one niche but too low in another.
          </p>
          <p>
            Instead of chasing a number, compare your website authority with
            competitors in your space. That’s what really matters. If their DA
            is 45 and yours is 38, you’re close. If their PA on a blog post is
            60 and yours is 20, you’ve got some catching up to do.
          </p>
          <p>
            Use the domain SEO check and even the bulk domain authority checker
            to run a few comparisons. It’ll help you spot where you stand in
            your niche.
          </p>

          <h3>How to Boost Your DA and PA</h3>
          <p>Here’s the part that matters: how do you improve these scores?</p>
          <p>
            The truth is, there’s no shortcut. You need real backlinks from
            websites that are relevant to your industry. That means:
          </p>
          <ul>
            <li>Creating content people want to link to</li>
            <li>Reaching out to sites in your niche</li>
            <li>Earning guest posts on credible blogs</li>
            <li>Avoiding shady link schemes or cheap directories</li>
          </ul>
          <p>
            And don’t forget internal structure. Make sure your important pages
            are linked properly within your site. That can help improve PA for
            the pages you want to rank.
          </p>
          <p>
            Using the website authority analyzer or free DA PA checker regularly
            will help you track your progress. If your DA and PA are rising,
            you’re on the right path. If not, it might be time to rethink your
            strategy.
          </p>

          <h3>Real Ways to Use the Website Authority Analyzer</h3>
          <p>
            This tool is not just for curiosity. Here’s how real people use the
            website authority analyzer or free DA PA checker daily:
          </p>
          <ul>
            <li>
              <strong>Tracking Progress:</strong> As you build backlinks, your
              DA and PA should slowly rise. A monthly domain SEO check helps
              keep you aligned.
            </li>
            <li>
              <strong>Competitor Research:</strong> Run a quick check on top
              competitors. If their DA is much higher, look into their backlink
              sources.
            </li>
            <li>
              <strong>Link Vetting:</strong> Before you pitch a site for a
              backlink, check domain authority. No point wasting time on weak
              domains.
            </li>
            <li>
              <strong>Client Reporting:</strong> If you're handling SEO for
              others, showing an increase in DA and PA proves your strategy is
              working.
            </li>
          </ul>
          <div className=" mb-3 d-flex justify-content-center">
            <img
              style={{ width: "50vw" }}
              className="mb-3"
              src={tool5}
              alt="seobix"
            />
          </div>
          <p>
            SeoBix keeps all this simple — no signups, just results. Use the
            bulk domain authority checker if you’re managing multiple sites or
            clients.
          </p>

          <h3>FAQs</h3>
          <p>
            <strong>Q: Is domain authority a real ranking factor?</strong>
            <br />
            Not directly. Google doesn’t use DA or PA, but the things those
            scores are based on — backlinks and authority of referring domains —
            do affect rankings.
          </p>
          <p>
            <strong>Q: How often should I check domain authority?</strong>
            <br />
            Once a month is usually enough. Authority doesn’t change overnight,
            so give it time.
          </p>
          <p>
            <strong>Q: Can I check multiple domains together?</strong>
            <br />
            Yes. Use our bulk domain authority checker to check dozens (or even
            hundreds) of domains at once.
          </p>
          <p>
            <strong>Q: What’s a good DA score?</strong>
            <br />
            It depends on your industry. There’s no perfect number. Compare with
            others in your niche to get a sense of where you stand.
          </p>
          <p>
            <strong>
              Q: Do I need an account to use the website authority analyzer?
            </strong>
            <br />
            Nope. Just open the tool, paste in your domain, and hit search.
            That’s it.
          </p>

          <h3>Final Thoughts</h3>
          <p>
            Authority isn’t about chasing numbers. It is about building a strong
            foundation that helps everything else in your SEO strategy work
            better.
          </p>
          <p>
            When your domain has authority, your content ranks faster, your
            links matter more, and your credibility goes up with users and with
            search engines.
          </p>
          <p>
            With SeoBix’s website authority analyzer, you can finally see where
            you stand. And if you're managing more than one site, our bulk
            domain authority checker saves you hours of effort.
          </p>
          <p>
            So if you’ve been wondering how strong your site is, don’t guess,
            check it.
          </p>
          <p>
            <strong>
              Try our domain SEO check today. No signups, no tools to install.
              Just clear, useful data that helps you make better decisions.
            </strong>
          </p>
          <div className="d-flex justify-content-center mt-4">
            <Button
              onClick={() => setShowMore(false)}
              style={{
                padding: "6px 20px",
                backgroundColor: "#fff",
                color: "#dc3545",
                fontWeight: "600",
                fontSize: "0.95rem",
                border: "2px solid #dc3545",
                borderRadius: "999px",
                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#dc3545";
                e.target.style.color = "#fff";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#fff";
                e.target.style.color = "#dc3545";
              }}
            >
              Hide
            </Button>
          </div>
        </>
      )}
      <Plancard />
      <Trialcards />
      <Related />
      <TestimonialPage />
      <Specialoffer />
      <BackLinkCards />
      <Plancard />
    </div>
  );
};
const Plancard = () => {
  const [isYearly, setIsYearly] = useState(false);
  const plans = [
    {
      title: "Free",
      monthly: "$0",
      yearly: "$0",
      Free: "3 Month Free Trial",
      features: ["Limited Access"],
      buttonText: "Buy Plan",
      color: "#e0f2fe",
      border: "#38bdf8",
      image: pay,
    },
    {
      title: "Basic",
      monthly: "$150/mo",
      features: ["5 Projects", "Standard Reports", "Email Support"],
      buttonText: "Buy Plan",
      color: "#e7f5ff",
      border: "#339af0",
      image: pay,
    },
    {
      title: "Standard",
      monthly: "$350/mo",
      features: ["10 Projects", "Advanced Reports", "Priority Support"],
      buttonText: "Buy Plan",
      color: "#e6fcf5",
      border: "#20c997",
      image: pay,
    },
    {
      title: "Premium",
      monthly: "$750/mo",
      features: ["Unlimited Projects", "All Features", "24/7 Support"],
      buttonText: "Buy Plan",
      color: "#fff3bf",
      border: "#fcc419",
      image: pay,
    },
  ];

  return (
    <Container className="my-5">
      <div className="text-center mb-4">
        <h2 style={{ fontWeight: "700", fontSize: "2rem" }}>
          Boost Your SEO With Our Amazing Plans
        </h2>
        <h4 className="font-weight-bold mb-4" style={{ color: "#441752" }}>
          🚀 Improve Your Rankings —{" "}
          <span style={{ color: "#FC4100" }}>
            Try Our Service Free for 3 Months!
          </span>
        </h4>
        <p style={{ color: "#6b7280" }}>
          Flexible pricing plans designed for every stage of your journey
        </p>
        <div className="d-flex justify-content-center mt-4">
          <div className="d-flex align-items-center gap-2">
            <span style={{ fontWeight: "500" }}>Monthly</span>

            <div
              className="m-2"
              style={{ transform: "scale(1.5)", transformOrigin: "center" }}
            >
              <Form.Check
                type="switch"
                id="custom-switch"
                checked={isYearly}
                onChange={() => setIsYearly(!isYearly)}
              />
            </div>

            <div className="d-flex align-items-center gap-2">
              <span style={{ fontWeight: "500" }}>Yearly</span>

              <div
                className="start-now-btn mx-3"
                style={{
                  backgroundColor: "#e6f4ea",
                  color: "#2f855a",
                  padding: "6px 12px",
                  borderRadius: "8px solid",
                  fontWeight: "600",
                  fontSize: "0.9rem",
                  border: "1px solid #20c997",
                }}
              >
                🎉{" "}
                <span style={{ color: "#0B1D51" }}>
                  Get{" "}
                  <span style={{ color: "#0B1D51" }}>
                    <b>30% OFF</b>
                  </span>{" "}
                  on Yearly Plans
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Row className="g-4 justify-content-center">
        {plans.map((plan, idx) => (
          <Col md={6} lg={3} key={idx}>
            <div style={{ position: "relative" }}>
              {plan.title === "Free" && (
                <div
                  style={{
                    position: "absolute",
                    top: "-12px",
                    left: 0,
                    right: 0,
                    height: "32px",
                    backgroundColor: "#38bdf8",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    borderTopLeftRadius: "16px",
                    borderTopRightRadius: "16px",
                    zIndex: 2,
                  }}
                >
                  {plan.Free}
                </div>
              )}

              <Card
                className="p-2"
                style={{
                  backgroundColor: plan.color,
                  border: `2px solid ${plan.border}`,
                  borderRadius: "16px",
                  textAlign: "center",
                  height: "100%",
                  boxShadow:
                    plan.title === "Free"
                      ? "0 12px 28px rgba(56, 189, 248, 0.5)"
                      : "0 4px 12px rgba(0,0,0,0.05)",
                  marginTop: plan.title === "Free" ? "16px" : "0",
                }}
              >
                <Card.Body>
                  <Card.Title style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                    {plan.title}
                  </Card.Title>
                  <h3 style={{ fontWeight: "bold", margin: "1rem 0" }}>
                    {isYearly
                      ? plan.title === "Free"
                        ? plan.yearly
                        : (() => {
                            const monthlyPrice = parseFloat(
                              plan.monthly.replace(/[^0-9.]/g, "")
                            );
                            const yearlyRaw = monthlyPrice * 12;
                            const discounted = yearlyRaw * 0.7;
                            return `$${Math.round(discounted)}/yr`;
                          })()
                      : plan.monthly}
                  </h3>
                  <a
                    href="/register"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-block",
                      backgroundColor: plan.border,
                      color: "white",
                      textDecoration: "none",
                      borderRadius: "999px",
                      padding: "8px 20px",
                      fontWeight: "600",
                      marginTop: "1rem",
                    }}
                  >
                    {plan.buttonText}
                  </a>

                  <div className="mt-3">
                    <img
                      src={plan.image}
                      alt={plan.title}
                      style={{
                        // width: "15vw",
                        objectFit: "contain",
                        marginBottom: "1rem",
                      }}
                    />
                  </div>
                </Card.Body>
              </Card>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};
const Trialcards = () => {
  const cardsData = [
    {
      keyImg: key1,
      coreImg: core5,
      title: "Integrated Search Console, Google Trends and Google Analytics",
      desc: "Smarter SEO insights in one place and see what’s popular in different countries and other website matrics. Seobix makes it easy and effective.",
    },
    {
      keyImg: key2,
      coreImg: core4,
      title: "Search Engine Optimization",
      desc: "SEO gets easier with SeoBix whether you just start your website or growing your online presence. Our all-in-one SEO tool helps you fix issues and improve online visibility.",
    },
    {
      keyImg: key3,
      coreImg: core2,
      title: "Social Media Optimization",
      desc: "You can monitor and post from all your favorite platforms, YouTube, Facebook, LinkedIn, and Instagram, all from under one roof.",
    },
    {
      keyImg: key4,
      coreImg: core1,
      title: "Competitive Research Overview",
      desc: "You can check domain overview and website age and how their pages look on Google with our SERP Simulator. Seobix gives you the insights you need to compete smarter, not harder.",
    },
    {
      keyImg: key5,
      coreImg: core3,
      title: "Structure Data",
      desc: "With the right setup, At Seobix, we make it super easy to add and check structured data, so your site gets noticed for all the right reasons.",
    },
    {
      keyImg: key6,
      coreImg: core6,
      title: "Keyword Research",
      desc: "Our Bix keyword Research helps you discover high-potential keywords your audience is actually searching for.",
    },
  ];
  return (
    <div className="mt-md-5 mt-3 m-md-0 m-2 ">
      <h2
        className="text-center m-4"
        style={{ fontWeight: "700", fontSize: "2rem" }}
      >
        What Includes In All Plans ?
      </h2>
      <div className="row m-0 p-0">
        {cardsData.map((card, index) => (
          <div key={index} className="col-12 col-md-4 p-2 d-flex">
            <div className="card w-100 h-100 p-2">
              <div className="d-flex h-100">
                <div
                  style={{ flex: 1 }}
                  className="d-flex flex-column position-relative"
                >
                  <div>
                    <img
                      src={card.keyImg}
                      alt={card.title}
                      style={{
                        height: "5vh",
                        objectFit: "contain",
                        marginBottom: "0.5rem",
                      }}
                    />
                    <h5>{card.title}</h5>
                  </div>
                </div>

                <div
                  style={{ flex: 1 }}
                  className="d-flex align-items-center justify-content-center"
                >
                  <img
                    src={card.coreImg}
                    alt={card.title}
                    className="img-fluid"
                    style={{ maxHeight: "200px", objectFit: "contain" }}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
const Specialoffer = () => {
  return (
    <div
      className="start-now-btn p-2"
      style={{
        background: "#799EFF",
        borderRadius: "24px",
        color: "white",
        textAlign: "center",
        margin: "3rem auto",
        width: "90%",
        maxWidth: "1000px",
        position: "relative",
      }}
    >
      <h2 className="mb-3" style={{ fontSize: "2rem", fontWeight: "bold" }}>
        Let’s do this! Start unlocking powerful backlink insights.
      </h2>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "16px",
          flexWrap: "wrap",
        }}
      >
        <a
          // href="/register"
          onClick={() => window.open("https://dashboard.seobix.com/", "_blank")}
          style={{
            backgroundColor: "#fff",
            color: "#000",
            padding: "12px 24px",
            borderRadius: "12px",
            fontWeight: "600",
            textDecoration: "none",
            minWidth: "150px",
            textAlign: "center",
          }}
        >
          Start 3 Months Free Trial
        </a>
      </div>

      <p style={{ color: "#fff", marginTop: "20px", fontSize: "14px" }}>
        <b> Full access — No Credit card Needed.</b>
      </p>
    </div>
  );
};
const Related = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [selfDomain, setSelfDomain] = useState("");
  const [competitorDomain, setCompetitorDomain] = useState("");
  const [selectedDomainType, setSelectedDomainType] = useState({
    value: "root",
    label: "Root Domain",
  });
  const { password, username } = basicauth;
  const base64Credentials = btoa(`${username}:${password}`);
  const [expandedRow, setExpandedRow] = useState(null);
  const [apiData, setApiData] = useState([]);
  const handleRowExpand = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
  };
  const generateUUID = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };
  const handleSubmit = async () => {
    const uuid = generateUUID();
    const session = generateUUID();
    const urls = [selfDomain, competitorDomain].filter(Boolean);
    setLoading(true);
    const scope = selectedDomainType.value === "root" ? "domain" : "subdomain";
    const requestData = {
      uuid,
      urls,
      scope,
      session,
    };
    console.log("Request Data:", requestData);
    try {
      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/CompetitiveResearch/FetchBulkSiteMetrics`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        }
      );

      const data = await response.json();
      if (data.status === "0") {
        setApiData(data.data);
        setLoading(false);
      } else {
        console.error("Error fetching data:", data.msg);
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setLoading(false);
    }
  };

  const handleClick = () => {
    navigate("/keyword-gap");
  };

  return (
    <div className="mt-5 mb-5">
      <div
        // onClick={handleClick}
        style={{
          cursor: "pointer",
        }}
      >
        <Row
          className="justify-content-center"
          style={{
            margin: "0",
            background:
              "linear-gradient(to right, #AFDDFF 0%, #C5E7FF 30%, #DAF0FF 60%, #EDF8FF 85%, #FFFFFF 100%)",
            borderRadius: "12px",
            transition: "transform 0.2s ease",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "scale(1.01)")
          }
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          <Col md={10} className="p-3">
            <h3 className="text-center">
              <b>Find Keyword Gaps vs Your Competitors</b>
            </h3>
            <p className="text-center">
              Discover which keywords your competitors rank for — but you don’t.
              Uncover missed SEO opportunities and boost your content strategy.
            </p>

            <Form className="mb-2">
              <Row className="align-items-center gx-2">
                <Col md={4}>
                  <Form.Group className="mb-0">
                    <Form.Control
                      type="text"
                      placeholder="Enter your domain"
                      value={selfDomain}
                      onChange={(e) => setSelfDomain(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-0">
                    <Form.Control
                      type="text"
                      placeholder="Enter competitor domain"
                      value={competitorDomain}
                      onChange={(e) => setCompetitorDomain(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Row className="g-2 align-items-center">
                    <Col xs={9}>
                      <Form.Group className="mb-0">
                        <Form.Select
                          value={selectedDomainType}
                          onChange={(e) =>
                            setSelectedDomainType(e.target.value)
                          }
                          aria-label="Select Domain Type"
                          style={{
                            borderRadius: "6px",
                            padding: "0.5rem",
                            fontWeight: "500",
                            color: "#333",
                            backgroundColor: "#fff",
                            border: "1px solid #ccc",
                          }}
                        >
                          <option value="">Select Domain Type</option>
                          <option value="root">Root Domain</option>
                          <option value="sub">Sub Domain</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col xs={3}>
                      <Button
                        size="sm"
                        variant="primary"
                        onClick={handleSubmit}
                        style={{ whiteSpace: "nowrap", width: "100%" }}
                      >
                        Submit
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
            <div className=" mt-4">
              {apiData.length > 0 && (
                <Table responsive>
                  <colgroup>
                    <col style={{ width: "25%" }} />
                    <col style={{ width: "20%" }} />
                    <col style={{ width: "20%" }} />
                    <col style={{ width: "20%" }} />
                  </colgroup>

                  <thead>
                    <tr>
                      <th className="text-center">Domain</th>
                      <th className="px-3">Domain Authority</th>
                      <th className="px-3">Page Authority</th>
                      <th className="px-3">Spam Score</th>
                    </tr>
                  </thead>
                  <tbody>
                    {apiData.map((item, index) => (
                      <React.Fragment key={item.id}>
                        <tr>
                          <td className="text-center">{item.url}</td>

                          <td
                            className="p-2"
                            style={{ width: "100px", textAlign: "center" }}
                          >
                            <CustomDoughnut
                              value={item.da}
                              stroke="#799EFF"
                              label={`${item.da}`}
                            />
                          </td>

                          <td
                            className="p-2"
                            style={{ width: "100px", textAlign: "center" }}
                          >
                            <CustomDoughnut
                              value={item.pa}
                              stroke="#FFA500"
                              label={`${item.pa}`}
                            />
                          </td>

                          <td
                            className="p-2"
                            style={{ width: "100px", textAlign: "center" }}
                          >
                            <CustomDoughnut value={item.spam_score} />
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                  </tbody>
                </Table>
              )}
            </div>
            <h6 className="text-end m-4" onClick={handleClick}>
              Click to get more details <FaArrowRight />
            </h6>
          </Col>
        </Row>
      </div>
    </div>
  );
};
const CustomDoughnut = ({ value, size = 64 }) => {
  const strokeWidth = 10;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const progress = ((100 - value) / 100) * circumference;

  return (
    <div
      style={{
        width: `${size}px`,
        height: `${size}px`,
        position: "relative",
      }}
    >
      <svg width={size} height={size}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="#e0e0e0"
          strokeWidth={strokeWidth}
          fill="none"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="#799EFF"
          strokeWidth={strokeWidth}
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={progress}
          strokeLinecap="round"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          fontSize: "14px",
          fontWeight: "bold",
          color: "#0A3981",
        }}
      >
        {value}%
      </div>
    </div>
  );
};
const cardData = [
  {
    title: "Backlink Checker",
    description:
      "Easy Find out which links are missing or harmful on your site and which are not.",
    linkText: "Backlink Checker",
    linkUrl: "/backlink-checker",
    bgColor: "#f4f7fb",
  },
  {
    title: "Top Pages",
    description:
      "Compare and analyze the performance of your most linked pages and that of your competitors. Learn about high-impact SEO opportunities.",
    linkText: "Top Pages",
    linkUrl: "/top-pages",
    bgColor: "#dff5ff",
  },
  {
    title: "Link Building Tool",
    description:
      "Determine broken or lost backlinks and turn them into new opportunities to establish stronger relations.",
    linkText: "Link Building Tool",
    linkUrl: "/link-building-tool",
    bgColor: "#f4f7fb",
  },
  {
    title: "Domain Authority",
    description:
      "Assess the authority rating and any future search engine of a web site with more than 15 reliable ranking factors and domain measures.",
    linkText: "DA Checker",
    linkUrl: "/da-pa-checker",
    bgColor: "#d6ffd6",
  },
];
const BackLinkCards = () => {
  return (
    <div style={{ overflow: "hidden", padding: "20px" }}>
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold">
            Backlink Optimization Toolkit: Everything You Need
          </h2>
        </div>
        <div className="row justify-content-center g-4">
          {cardData.map((card, index) => (
            <div key={index} className="col-md-6 col-lg-3 p-1">
              <div
                style={{
                  backgroundColor: card.bgColor,
                  padding: "24px",
                  borderRadius: "20px",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <h5 className="fw-bold">{card.title}</h5>
                  <p className="text-muted" style={{ fontSize: "15px" }}>
                    {card.description}
                  </p>
                </div>
                <div>
                  <a
                    href={card.linkUrl}
                    className="text-primary fw-semibold"
                    style={{ textDecoration: "none" }}
                  >
                    {card.linkText} →
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default Domainoverview;
